<template>
    <modal @close="$emit('close')">
        <template slot="header">
            Vultr account -
            <template v-if="form._id">edit</template>
            <template v-if="!form._id">add new</template>
        </template>
        <fieldset class="mb-3" :class="{ 'loading-mask': loading }">
            <div class="form-group row">
                <label class="col-form-label col-lg-2">Name</label>
                <div class="col-lg-4">
                    <input type="text" class="form-control" v-model="form.name">
                </div>
            </div>
            <div class="form-group row">
                <label class="col-form-label col-lg-2">Api key</label>
                <div class="col-lg-4">
                    <input type="text" class="form-control" v-model="form.api_key">
                </div>
            </div>
            <div class="form-group row">
                <label class="col-form-label col-lg-2" @click="check_api">Check API keys</label>
                <div class="col-lg-8">
                    <div class="form-check form-check-inline">
                        <div class="uniform-checker">
                            <span :class="{ 'checked': check_api }">
                                <input type="checkbox" class="form-check-input-styled" v-model="check_api">
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="alert alert-danger" v-if="err">{{ err }}</div>
            <div class="form-group row">
                <label class="col-form-label col-lg-12">
                    <button type="button" class="btn btn-primary" @click="save()">Save</button>
                    <button class="btn btn-link" @click="$emit('close')">Cancel</button>
                </label>
            </div>
        </fieldset>
    </modal>
</template>
<script>
import modal from '../common/Modal.vue'

export default {
    components: { modal },
    props: {
        obj: null
    },
    data() {
        return {
            form: {
                _id: null,
                name: null,
                api_key: null,
            },
            ips: [],
            err: null,
            loading: false,
            check_api: true,
        }
    },
    methods: {
        save() {

            if (!this.check_api) {
                return this._save()
            }

            this.loading = true
            this.$api.postReq('test_api_access', {
                provider: 'vultr',
                api_key: this.form.api_key,
            }).then(res => {
                this._save()
            }).catch(res => {
                this.err = 'Cannot connect to API, invalid API keys'
                this.loading = false
            })
        },
        _save() {
            this.loading = true
            this.$api.postReq('accounts/vultr', this.form).then(res => {
                this.$emit('close')
                this.$emit('reload')
            }).catch(res => {
                this.err = res.body.error
            })
        }
    },
    mounted() {

        if (this.obj !== true) {
            this.form = this.obj
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/modal/Vultr.vue